export const ASSIGNED_COLOR_CLASSNAMES = "bg-yellow-200 text-gray-800"
